<template>
  <div class="dashboard-widget-template widget-one-to-one-meetings" v-loading="loadingWidgetResult">
    <div v-if="!loadingWidgetResult && !widgetResult.length" class="one-to-one-widget-empty">
      <i class="fas fa-calendar-check"></i>
      <div>Нет предстоящих встреч</div>
    </div>

    <div v-else class="one-to-one-widget-list">
      <div
        v-for="meeting in widgetResult"
        :key="meeting.id"
        class="one-to-one-meeting-row"
        @click="openMeeting(meeting)"
      >
        <div class="one-to-one-meeting-row-date">
          <div class="one-to-one-meeting-row-date-day">{{ formatDate(meeting.date) }}</div>
          <div v-if="meeting.time" class="one-to-one-meeting-row-date-time">{{ meeting.time.slice(0,5) }}</div>
        </div>

        <div class="one-to-one-meeting-row-body">
          <div class="one-to-one-meeting-row-title">{{ counterpartName(meeting) }}</div>
          <div class="one-to-one-meeting-row-meta">
            {{ typeName(meeting.type) }}
            <span v-if="meeting.location"> · {{ meeting.location }}</span>
          </div>
        </div>

        <el-tag
          size="mini"
          :type="$oneToOneConstants.meetings.statusTypes[meeting.status]"
        >{{ statusName(meeting.status) }}</el-tag>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {WidgetViewMixin} from "@/components/home/dashboard/widgets/WidgetViewMixin";
import {Constants as $oneToOneConstants} from "@/modules/oneToOne/base/oneToOneConstants";

export default {
  name: 'OneToOneMeetingsWidgetTemplate',
  mixins: [WidgetViewMixin],
  props: {},
  computed: {
    ...mapGetters({currentUser: 'user'}),
    $oneToOneConstants() {
      return $oneToOneConstants;
    },
  },
  mounted() {
    this.loadWidgetResult({
      expand: 'initiator,participant',
    })
      .then(() => {
        this.widgetResult = this.widgetResult || [];
      });
  },
  data() {
    return {
      widgetResult: [],
    };
  },
  methods: {
    formatDate(date) {
      if (!date) return '';
      return (new Date(date)).toLocaleDateString(this.$companyConfiguration.helpers.getDateLocale(), {day: '2-digit', month: '2-digit'});
    },
    typeName(type) {
      const opt = this.$oneToOneConstants.meetings.typeSelectOptions.find(e => e.id === type);
      return opt ? opt.name : type;
    },
    statusName(status) {
      const opt = this.$oneToOneConstants.meetings.statusesSelectOptions.find(e => e.id === status);
      return opt ? opt.name : status;
    },
    counterpartName(meeting) {
      const isInitiator = this.currentUser && meeting.initiator && meeting.initiator.id === this.currentUser.id;
      const counterpart = isInitiator ? meeting.participant : meeting.initiator;
      return counterpart ? counterpart.full_name : '—';
    },
    openMeeting(meeting) {
      if (this.editMode) {
        return;
      }
      if( this.data.openInNewWindow ){
        let route = this.$router.resolve({ name: 'OneToOneMeeting', params: { id: meeting.id } });
        window.open(route.href);
      } else {
        this.$router.push({name: 'OneToOneMeeting', params: {id: meeting.id}});
      }
    },
  },
}
</script>

<style lang="scss">
.widget-one-to-one-meetings {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  padding: 8px;
  box-sizing: border-box;

  .one-to-one-widget-empty {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #9CA3AF;
    gap: 8px;

    i {
      font-size: 24px;
    }
  }

  .one-to-one-widget-list {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .one-to-one-meeting-row {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 8px 10px;
    border: 1px solid #eceef1;
    border-radius: 6px;
    cursor: pointer;
    transition: border-color .15s ease, box-shadow .15s ease;

    &:hover {
      border-color: #d1d5db;
      box-shadow: 0 2px 8px rgba(17, 24, 39, 0.06);
    }

    &-date {
      flex: 0 0 auto;
      width: 48px;
      text-align: center;

      &-day {
        font-weight: 600;
        font-size: 13px;
      }

      &-time {
        font-size: 12px;
        color: #6b7280;
      }
    }

    &-body {
      flex: 1;
      min-width: 0;
    }

    &-title {
      font-weight: 500;
      font-size: 13px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    &-meta {
      font-size: 12px;
      color: #6b7280;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
</style>
